let ctx;

// Plays a short two-tone "ding" chime for new messages using the Web Audio API
// (no audio file needed). Silently no-ops if audio is blocked.
export function playChime() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    const gain = ctx.createGain();
    gain.connect(ctx.destination);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.25, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.45);

    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, now);        // A5
    osc.frequency.setValueAtTime(1174.66, now + 0.13); // D6
    osc.connect(gain);
    osc.start(now);
    osc.stop(now + 0.45);
  } catch (e) {
    /* audio unavailable / blocked — ignore */
  }
}
